import { render, staticRenderFns } from "./ServiceDiscounts.vue?vue&type=template&id=07c20cdf"
import script from "./ServiceDiscounts.vue?vue&type=script&lang=js"
export * from "./ServiceDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports